








































































































































































































import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { menuServe, roleServe, spaceServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import TreeContainer from '@/components/tree/tree.vue';
import { deepClone } from '@/util/deepClone';

@Component({
  components: { TreeContainer },
})
export default class CompanyEdit extends Vue {
  // 父组件传递过来的控制编辑页面: 1：主页面 2：编辑页面 3：新增下级页面 4：新增页面
  @PropSync('showFlag', Number) showWhatFlag!: number;
  @Prop(String) row!: string; // 父组件传递过来的需要修改一行的数据
  @Prop(String) rowId!: any; // 传递给编辑页面,角色分配功能权限页面的表单数据对象123
  antiShake = true; // 控制防抖
  // scrollbar = false;
  functionMenu: Array<any> = []; // 树状图数据
  // 空间信息表单数据
  spaceFormData: object = {
    superName: '', // 上级空间
    pid: null, // 父级空间 id
    name: '', // 空间名称
    sort: '', // 排序号
    enabled: '', // 是否启用
  };
  functionFormData: any = {
    functionMenuList: [], // 授权功能菜单的树
  };
  functionFormDataClone: any = {}; // 克隆的树
  // 用户信息表单数据
  userFormData: object = {
    username: '', // 用户名称
    password: '', // 密码
    nickname: '', // 昵称
    mobile: '', // 手机号
    email: '', // 邮箱
  };
  // 员工信息表单数据
  staffFormData: object = {
    name: '', // 人员名称
    sex: '', // 性别
    jobNum: '', // 工号
    hireDate: '', // 雇用日期
    fireDate: '', // 解雇日期
    education: '', // 学历
    deptPrincipal: '', // 是否是科室负责人
    birthDate: '', // 出生日期
    address: '', // 详细地址
  };
  // 授权菜单表单数据
  menuFormData: object = {
    authorizationMenuIds: '', // 授权菜单数组
  };

  // 空间验证规则
  spaceRules: object = {
    name: [{ required: true, trigger: 'change', message: '必填信息' }],
    sort: [{ required: true, trigger: 'change', validator: this.sortValidator }],
    enabled: [{ required: true, trigger: 'change', message: '必填信息' }],
  };
  // 用户信息验证规则
  userRules: object = {
    username: [{ required: true, trigger: 'blur', validator: this.userNameValidator }],
    password: [{ required: true, trigger: 'blur', validator: this.psdValidator }],
    nickname: [{ required: true, trigger: 'blur', message: '必填信息' }],
    mobile: [{ required: true, trigger: 'blur', validator: this.mobileeValidator }],
    email: [{ required: true, trigger: 'blur', validator: this.emaliValidator }],
  };
  // 员工信息验证规则
  staffRules: object = {
    name: [{ required: true, trigger: 'blur', message: '必填信息' }],
    jobNum: [{ required: true, trigger: 'blur', message: '必填信息' }],
    sex: [{ required: true, trigger: 'change', message: '必填信息' }],
  };
  // 授权菜单验证规则
  menuRules: object = {
    authorizationMenuIds: [{ type: 'array', required: true, trigger: 'change', message: '必填信息' }],
  };
  dialogVisible = false; // dialog 是否显示
  dialogTitle = ''; // dialog 的标题
  searchCompany = ''; // dialog 里的搜索input数据
  checkNode: any = null; // tree选中节点的数据
  // dialog 中树节点数据对象
  treeData: any[] = [];
  // 菜单树数据对象
  menuTreeData: any[] = [];
  // dialog 中树形图的属性
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };

  mounted() {
    // this.hasScrollbar();
  }

  // hasScrollbar() {
  //   const dom: any = document.querySelector('.main');
  //   if (dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight) {
  //     this.scrollbar = true;
  //   } else {
  //     this.scrollbar = false;
  //   }
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc Vue 创建数据生命周期函数，获得从父组件传递过来的数据.
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    console.log(this.functionFormData.functionMenuList, 123);
    console.log(this.row, 456);
    // 1：主页组件 2：编辑 3：新增下级 4：新增
    if (this.showWhatFlag === 2) {
      // 先获取自身空间数据：name pid id sort enabled
      spaceServe
        .getData(this.row)
        .then((res: any) => {
          if (res.code === '200') {
            (this.spaceFormData as any).pid = res.data.pid; // 父级空间 id
            (this.spaceFormData as any).id = res.data.id; // 自身 id
            (this.spaceFormData as any).name = res.data.name; // 自身名称
            (this.spaceFormData as any).sort = res.data.sort; // 排序号
            (this.spaceFormData as any).enabled = res.data.enabled; // 是否启用
            if (res.data.pid != null) {
              // 当有父级空间时,获取到父级空间的名称
              spaceServe
                .getData(res.data.pid)
                .then((res: any) => {
                  if (res.code === '200') {
                    (this.spaceFormData as any).superName = res.data.name; // 得到父级空间 name
                  }
                })
                .catch(() => {
                  this.$message.error('获取父级空间数据失败,请稍后重试!');
                });
            }
          }
        })
        .catch(() => {
          this.$message.error('初始化数据失败,请稍后重试!');
        });
    } else if (this.showWhatFlag === 3) {
      // 获取到上级空间的 id 和上空间的 name
      spaceServe
        .getData(this.row)
        .then((res: any) => {
          if (res.code === '200') {
            (this.spaceFormData as any).pid = res.data.id; // 得到 pid
            (this.spaceFormData as any).superName = res.data.name; // 得到 上级空间的 name
          }
        })
        .catch(() => {
          this.$message.error('初始化数据失败,请稍后重试!');
        });
      // 初始化授权菜单树数据
      menuServe
        .sysMenuList({})
        .then((res: any) => {
          this.menuTreeData = arrayToTree(res.data);
        })
        .catch(() => {
          this.$message.error('初始化授权菜单失败,请稍后重试!');
        });
    } else if (this.showWhatFlag === 4) {
      // 初始化授权菜单树数据
      menuServe
        .sysMenuList({})
        .then((res: any) => {
          this.menuTreeData = arrayToTree(res.data);
        })
        .catch(() => {
          this.$message.error('初始化授权菜单失败,请稍后重试!');
        });
    }
    this.getFunctionData();
  }

  getFunctionData() {
    menuServe
      .sysMenuList({})
      .then((res: any) => {
        if (res.code === '200') {
          console.log('res的', res); // 输出全部数据
          this.functionMenu = arrayToTree(res.data);
          setTimeout(() => {
            this.getFunctionInfo();
          }, 500);
        }
      })
      .catch(() => {
        this.$message.error('初始化树状图失败，请稍后重试！');
      });
  }

  checkFunctionData(data: any) {
    console.log(data, 'data'); // 需要保存的 idList
    // this.functionFormData.functionMenuList = data.idList;
    this.functionFormDataClone.functionMenuList = data.idList;
  }

  getFunctionInfo() {
    // 通过id 获取数据
    menuServe
      .getCurrentSpace({
        // spaceId: 'ab5d2f327e4b4451bff18a5cde468e02',
        spaceId: this.row,
      })
      .then((res: any) => {
        // res.data.map((re: any) => {
        //   this.functionFormData.functionMenuList.push(re.id)
        // })
        res.data.forEach((item: any) => {
          this.functionFormData.functionMenuList.push(item.id);
          this.functionFormDataClone = deepClone(this.functionFormData);
        });
        // this.functionFormData.functionMenuList = res.data;
        // this.basicInfoDataClone = deepClone(res.data);
        // this.$forceUpdate();
        console.log('res123', res); // 每一行的数据
      })
      .catch((error: any) => {
        // this.$message({
        //   type: 'info',
        //   message: '网络错误，请检查网络',
        // });
        console.log(error);
      });
  }

  /**
   * @desc dialog 中搜索数据改变就会触发函数
   * @param1 暂无
   * @returns 暂无
   */
  @Watch('searchCompany')
  searchSapce() {
    this.getAllData({ name: this.searchCompany });
  }

  /**
   * @desc 获取符合条件的所有数据请求
   * @param1 data：筛选数据的条件对象
   * @returns 暂无
   */
  getAllData(data: any) {
    return spaceServe
      .getAllData(data)
      .then((res: any) => {
        if (res.code === '200') {
          this.treeData = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('初始化数据失败,请稍后重试!');
      });
  }

  /**
   * @desc 选中的数据
   * @param1
   * @returns 返回值描述
   */
  checkData(data: any) {
    // console.log('123');
    (this.menuFormData as any).authorizationMenuIds = data.idList; // 将选中的id数组赋值给表单数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 定义 表单  sort权重排序的验证规则
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 如果 value 是空的和number类型 就正常返回，否则报错
   */
  sortValidator(rule: any, value: any, callback: any) {
    if (value === '') {
      return callback(new Error('必填信息'));
    }
    if (typeof value !== 'number') {
      return callback(new Error('请输入一个正整数'));
    }
    if (value < 0) {
      return callback(new Error('请输入一个正整数'));
    }
    return callback();
  }

  /**
   * @desc  用户名称验证函数
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 暂无
   */
  userNameValidator(rule: any, value: any, callback: any) {
    if (value.length === 0) {
      return callback(new Error('必填信息'));
    }
    if (value.length < 8 || value.length > 20) {
      return callback(new Error('用户名长度在8-20位'));
    }
    return callback();
  }

  /**
   * @desc 邮箱验证规则
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 暂无
   */
  emaliValidator(rule: any, value: any, callback: any) {
    // 邮箱验证规则
    const reg = new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$');
    if (value.length === 0) {
      return callback(new Error('必填信息'));
    }
    if (!reg.test(value)) {
      return callback(new Error('邮箱格式不正确：必须含有@**.cn、或@**.com等'));
    }
    return callback();
  }

  /**
   * @desc 密码验证函数
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 暂无
   */
  psdValidator(rule: any, value: any, callback: any) {
    // 密码包含数字和字母
    const reg1 = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,20})$/;
    // 密码包含特殊符号
    const reg2 = /[`~!@#$%^&*()\-_+={}[\]|\\:;"'<>?,./]/;
    const rule1 = reg1.test(value) ? 1 : 0;
    const rule2 = reg2.test(value) ? 1 : 0;
    const isValid = rule1 + rule2;
    if (value.length === 0) {
      return callback(new Error('必填信息'));
    }
    if (isValid === 2) {
      return callback();
    } else {
      return callback(new Error('密码长度在8-20位，并且数字、字母、特殊符号至少各一位。'));
    }
    return callback();
  }

  /**
   * @desc 手机号验证函数
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 暂无
   */
  mobileeValidator(rule: any, value: any, callback: any) {
    if (value.length === 0) {
      return callback(new Error('必填信息'));
    }
    if (typeof value !== 'number') {
      return callback(new Error('手机号码不能是数字以外'));
    }
    if (value.toString().length !== 11) {
      return callback(new Error('手机号码长度为11位'));
    }
    return callback();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 打开 dialog 触发事件。
   * @param1 data：需要修改 formData 中的的数据
   * @param2 title: dialog 的标题
   * @param3 option：要修改的 formData 中的一个选项
   * @returns 暂无
   */
  async openDialog(data: string, title: string) {
    this.dialogTitle = title; // 设置 dialog 的标题
    await this.getAllData({}); // 初始化 树状图的数据
    this.dialogVisible = true; // 显示 dialog
    Vue.nextTick(() => {
      (this.$refs.searchOrganRef as any).focus();
      // 打开被选中的树
      this.openCheckedTree(this.treeData, data);
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 关闭 dialog 触发事件，清除内容。
   * @param1 暂无
   * @returns 暂无
   */
  closeDialog() {
    this.dialogVisible = false; // 关闭 dialog
    this.searchCompany = ''; // 清空搜索栏
    this.checkNode = null; // 清空选中的节点对象
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击上级机构的 input 触发事件，打开被选中的树节点。
   * @param1 tree: 树节点对象
   * @param2 name: 用于进行判断的名称
   * @returns 返回值描述
   */
  openCheckedTree(tree: any, name: string) {
    tree.forEach((item: any) => {
      if (item.name === name) {
        (this.$refs.dialogTreeRef as any).getNode(item.id).isCurrent = true;
        (this.$refs.dialogTreeRef as any).getNode(item.id).parent.expanded = true;
      } else if (item.children) {
        this.openCheckedTree(item.children, name);
      }
    });
  }

  /**
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data: any) {
    // 取消被选中的 树节点。
    (this.$refs.dialogTreeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.dialogTreeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    this.checkNode = data; // 选中的节点数据
  }

  /**
   * @desc 点击 dialog 里的提交按钮触发，提交修改值。
   * @param1 暂无
   * @returns 暂无
   */
  submitDialog() {
    if (this.checkNode) {
      (this.spaceFormData as any).superName = (this.checkNode as any).name; // 获取到上级空间的 name
      (this.spaceFormData as any).pid = (this.checkNode as any).id; // 获取到上级空间的 id
    }
    this.dialogVisible = false; // 关闭弹框
  }

  /**
   * @desc 点击 dialog 中的清除按钮触发，清除内容
   * @param1 暂无
   * @returns 暂无
   */
  clearDialog() {
    (this.spaceFormData as any).superName = ''; // 清空上级机构名称
    (this.spaceFormData as any).pid = ''; // 清空上级机构的 id;
    this.dialogVisible = false;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击保存按钮触发，保存内容。
   * @param1 暂无
   * @returns 暂无
   */
  save() {
    if (!this.antiShake) {
      return;
    }
    this.antiShake = false; // 开启防抖
    // 2: 编辑空间页面 3：新增下级 4：新增
    if (this.showWhatFlag == 2) {
      (this.$refs.spaceRef as any).validate((valid: any) => {
        if (valid) {
          // 获取需要的数据对象
          const obj = {};
          (obj as any).name = (this.spaceFormData as any).name; // 空间名称
          (obj as any).sort = (this.spaceFormData as any).sort; // 排序号
          (obj as any).enabled = (this.spaceFormData as any).enabled; // 是否启用
          (obj as any).id = (this.spaceFormData as any).id; // 要修改的 id
          if ((this.spaceFormData as any).name == '') {
            return false;
          } else {
            spaceServe
              .editData(obj)
              .then((res: any) => {
                if (res.code === '200') {
                  // this.$message.success('保存成功!');
                  // this.showWhatFlag = 1; // 跳转到主页
                  // this.antiShake = true; // 关闭防抖
                }
              })
              .catch(() => {
                this.$message.error('保存失败,请重试!');
                this.antiShake = true; // 关闭防抖
              });

            const a: any = this.functionFormData.functionMenuList.join('%2C');
            console.log(a, 699);
            spaceServe
              .editTreeData(
                {
                  spaceId: this.row,
                  // menuIds: a,
                },
                this.functionFormDataClone.functionMenuList,
              )
              .then((res: any) => {
                if (res.code === '200') {
                  this.$message.success('保存成功!');
                  this.showWhatFlag = 1; // 跳转到主页
                  // this.antiShake = true; // 关闭防抖
                }
              })
              .catch(() => {
                this.$message.error('保存树失败,请重试!');
                // this.antiShake = true; // 关闭防抖
              });
          }
        } else {
          this.antiShake = true; // 关闭防抖
          return false;
        }
      });
    } else {
      let flag = true;
      const refArr = ['spaceRef', 'userRef', 'staffRef', 'menuRef'];
      refArr.forEach((item: any) => {
        (this.$refs[item] as any).validate((valid: any) => {
          if (!valid) {
            flag = false; // 如果有一个没有验证就不能输出
            return false;
          }
        });
      });
      // 判断必填项全部填写
      if (flag) {
        // 得到符合格式的数据对象
        const obj = {};
        (obj as any).authorizationMenuIds = (this.menuFormData as any).authorizationMenuIds; // 授权菜单赋值
        (obj as any).space = {
          enabled: (this.spaceFormData as any).enabled, // 是否启用
          name: (this.spaceFormData as any).name, // 空间名称
          pid: (this.spaceFormData as any).pid, // 父级空间 id
          sort: (this.spaceFormData as any).sort, // 排序字段
        };
        (obj as any).staff = {
          name: (this.staffFormData as any).name, // 人员名称
          sex: (this.staffFormData as any).sex, // 性别
          jobNum: (this.staffFormData as any).jobNum, // 工号
          hireDate: (this.staffFormData as any).hireDate, // 雇用日期
          fireDate: (this.staffFormData as any).fireDate, // 解雇日期
          education: (this.staffFormData as any).education, // 学历
          deptPrincipal: (this.staffFormData as any).deptPrincipal, // 是否是科室负责人
          birthDate: (this.staffFormData as any).birthDate, // 生日
          address: (this.staffFormData as any).address, // 详细地址
        };
        (obj as any).user = {
          email: (this.userFormData as any).email, // email
          mobile: (this.userFormData as any).mobile, // 手机
          nickname: (this.userFormData as any).nickname, // 昵称
          username: (this.userFormData as any).username, // 用户名称
          password: (this.userFormData as any).password, // 密码
        };
        spaceServe
          .addData({ ...obj })
          .then((res: any) => {
            if (res.code === '200') {
              this.$message.success('保存成功!');
              this.showWhatFlag = 1; // 跳转到主页
              console.log(obj, '新增保存的');
            }
            this.antiShake = true; // 关闭防抖
          })
          .catch(() => {
            this.$message.error('保存数据失败,请稍后重试!');
            this.antiShake = true; // 关闭防抖
          });
      } else {
        this.antiShake = true; // 关闭防抖
      }
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮触发，返回上一级。
   * @param1 无
   * @returns 无
   */
  close() {
    this.showWhatFlag = 1;
  }
}
